/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : AuthButton.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import { Button } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import appTheme from "../../assets/AppTheme/appTheme";

function AuthButton({ type, btnName, handleOnClick }) {
  return (
    <Button
      fullWidth
      type={type}
      variant="contained"
      sx={styles.btnStyle}
      onClick={handleOnClick}
    >
      {btnName}
    </Button>
  );
}

AuthButton.propTypes = {
  type: PropTypes.string,
  btnName: PropTypes.string,
  handleOnClick: PropTypes.func,
};

AuthButton.defaultProps = {
  type: "button",
  btnName: "",
  handleOnClick: () => {},
};

export default AuthButton;

const styles = {
  btnStyle: {
    marginTop: 3,
    backgroundColor: "#2196F3",
    color: "#ffffff",
    textTransform: "none",
    ...appTheme.commonBtnStyle,
  },
};
